import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from '../../services/Auth';

class InterviewsApi extends Api {
  constructor() {
    super('interviews/interviews/');
  }

  getAnswer = (id) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/interviews/answers${id}`,
      method: 'get',
      data: {},
      params: {},
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };

  getExcelSingle = (id) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/interviews/answers${id}.xlsx`,
      method: 'get',
      data: {},
      params: {},
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };

  answerQuestions = (id, params, idCompany = '0') => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/interviews/answers/${idCompany}/${id}`,
      method: 'post',
      data: params.data,
      params: {},
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default InterviewsApi;
